import { responsiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const IMore: Site = {
  id: 'imore',
  logo: 'svg/imore.svg',
  label: 'IMore',
  analyticsName: 'imore',
  hostname: 'imore.com',
  platform: 'responsive',
  selector: `${responsiveVanillaSelector}, article a`,
};
